import { render } from "./CopyrightFooter.vue?vue&type=template&id=02b6ff0d&scoped=true"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js"

import "./CopyrightFooter.vue?vue&type=style&index=0&id=02b6ff0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b6ff0d"]])

export default __exports__